import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className="bg-gray-50 min-h-screen flex justify-center items-start py-12 px-4">
            <div className="bg-white rounded-2xl shadow-md max-w-4xl w-full p-8 md:p-12">
                <h1 className="text-3xl font-bold text-center text-gray-900 mb-2">
                    Privacy Policy for "TheBetterYou"
                </h1>
                <p className="text-center text-sm text-gray-500 mb-8">
                    Effective Date: November 11, 2023
                </p>

                <div className="prose prose-lg max-w-none text-gray-800">
                    <p>
                        Thank you for choosing <em>TheBetterYou</em>, a self-improvement mobile
                        application designed to support your personal growth and well-being.
                        This Privacy Policy explains how we collect, use, store, and protect
                        your personal information. We are committed to safeguarding your
                        privacy in compliance with the General Data Protection Regulation
                        (GDPR) and other applicable laws.
                    </p>

                    <h2>1. Information We Collect</h2>
                    <h3>1.1 Account Information</h3>
                    <p>
                        <strong>Email Address, Google Account, or Apple ID:</strong> When you
                        create an account, we collect your login credentials (depending on
                        the method you choose) to set up and manage your profile.
                    </p>

                    <h3>1.2 Assessment Data</h3>
                    <p>
                        When you complete the introductory personality test or any other
                        assessments (such as OCD, ADHD, anxiety, depression, and others),
                        your responses and results are stored securely to provide you with
                        personalized insights.
                    </p>

                    <h3>1.3 Journal Entries</h3>
                    <p>
                        You may choose to write personal notes in your private journal. All
                        journal entries are encrypted in our database to ensure
                        confidentiality and compliance with GDPR requirements.
                    </p>

                    <h3>1.4 Usage Information</h3>
                    <p>
                        We collect limited technical information, such as device type,
                        operating system, and usage patterns (e.g., which articles you read),
                        to improve app performance and user experience.
                    </p>

                    <h2>2. How We Use Your Information</h2>
                    <ul>
                        <li>Account Management: To create and maintain your user profile.</li>
                        <li>Personalized Insights: To generate test results and provide tailored content.</li>
                        <li>Journal Functionality: To securely store your encrypted notes, accessible only to you.</li>
                        <li>Communication: To send important updates or respond to support inquiries.</li>
                        <li>Improvement of Services: To analyze usage data and improve features, tests, and articles.</li>
                    </ul>

                    <h2>3. Data Protection and Security</h2>
                    <p>We apply strict technical and organizational measures to protect your personal data, including:</p>
                    <ul>
                        <li>End-to-end encryption for journal entries.</li>
                        <li>Secure storage of login information.</li>
                        <li>Restricted access only to authorized personnel who require it for app operation.</li>
                    </ul>

                    <h2>4. Data Sharing</h2>
                    <p>
                        We do <strong>not</strong> sell, trade, or rent your personal
                        information to third parties. Your data will only be shared if:
                    </p>
                    <ul>
                        <li>Required by law or legal process.</li>
                        <li>Necessary to protect the rights, safety, or integrity of TheBetterYou and its users.</li>
                        <li>
                            In case of third-party service providers (e.g., cloud hosting), who
                            are contractually obligated to comply with GDPR and maintain strict
                            data protection standards.
                        </li>
                    </ul>

                    <h2>5. Your Rights</h2>
                    <p>As a user under GDPR, you have the right to:</p>
                    <ul>
                        <li>Access your personal data.</li>
                        <li>Request correction or deletion of your data.</li>
                        <li>Restrict or object to certain processing activities.</li>
                        <li>Request a copy of your data in a portable format.</li>
                    </ul>
                    <p>
                        You may exercise these rights by contacting us at
                        <strong> team.thebetteryou@gmail.com </strong>.
                    </p>

                    <h2>6. Data Retention</h2>
                    <p>
                        We retain your information only as long as necessary to provide you
                        with the app’s services. If you delete your account, your personal
                        data (including tests and journal entries) will be permanently
                        deleted, except where retention is required by law.
                    </p>

                    <h2>7. Updates to This Policy</h2>
                    <p>
                        We may update this Privacy Policy from time to time to reflect changes
                        in technology, legal requirements, or our services. Significant
                        changes will be communicated within the app or via email.
                    </p>

                    <h2>8. Contact Us</h2>
                    <p>
                        If you have any questions, concerns, or requests regarding this
                        Privacy Policy or your data, please contact us at:
                        <br />
                        <strong>Email:</strong> team.thebetteryou@gmail.com
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
